export const offerCode = [
  {
    value: 'STD_CO',
    name: 'Standard Livraison Entreprise',
    professionalOffer: false,
    requiredCompanyName: true,
    id: 0
  },
  {
    value: 'STD_PRO_CO',
    name: 'Standard Pro Livraison Entreprise',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 1
  },
  {
    value: 'STD_PICKUP_POINT',
    name: 'Standard Relais',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 2
  },
  {
    value: 'STD_SIGN_CO',
    name: 'Standard Signature Livraison Entreprise',
    professionalOffer: false,
    requiredCompanyName: true,
    id: 3
  },
  {
    value: 'STD_PRO_SIGN_CO',
    name: 'Standard Pro Signature Livraison Entreprise',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 4
  },
  {
    value: 'STD',
    name: 'Standard',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 5
  },
  {
    value: 'STD_PRO',
    name: 'Standard Pro',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 6
  },
  {
    value: 'STD_SIGN',
    name: 'Standard Signature',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 7
  },
  {
    value: 'STD_PRO_SIGNATURE',
    name: 'Standard Pro Signature',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 8
  },
  {
    value: 'EXP_CO',
    name: 'Express Livraison Entreprise',
    professionalOffer: false,
    requiredCompanyName: true,
    id: 9
  },
  {
    value: 'EXP_PRO_CO',
    name: 'Express Pro Livraison Entreprise',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 10
  },
  {
    value: 'EXP_PICKUP_POINT',
    name: 'Express Relais',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 11
  },
  {
    value: 'EXP',
    name: 'Express',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 12
  },
  {
    value: 'EXP_PRO',
    name: 'Express Pro',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 13
  },
  {
    value: 'EXP_ENV_CO',
    name: 'Express Pli Livraison Entreprise',
    professionalOffer: false,
    requiredCompanyName: true,
    id: 14
  },
  {
    value: 'EXP_PRO_ENV_CO',
    name: 'Express Pro Pli Livraison Entreprise',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 15
  },
  {
    value: 'EXP_ENV',
    name: 'Express Pli',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 16
  },
  {
    value: 'EXP_PRO_ENV',
    name: 'Express Pro Pli',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 17
  },
  {
    value: 'EXP13_CO',
    name: 'Express+ Livraison Entreprise',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 18
  },
  {
    value: 'EXP13_PRO_CO',
    name: 'Express+ Pro Livraison Entreprise',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 19
  },
  {
    value: 'EXP13',
    name: 'Express+',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 20
  },
  {
    value: 'EXP13_PRO',
    name: 'Express+ Pro',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 21
  },
  {
    value: 'EXP13_ENV_CO',
    name: 'Express+ Pli Livraison Entreprise',
    professionalOffer: false,
    requiredCompanyName: true,
    id: 22
  },
  {
    value: 'EXP13_PRO_ENV_CO',
    name: 'Express+ Pro Pli Livraison Entreprise',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 23
  },
  {
    value: 'EXP13_ENV',
    name: 'Express+ Pli',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 24
  },
  {
    value: 'EXP13_PRO_ENV',
    name: 'Express+ Pro Pli',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 25
  },
  {
    value: 'EXP10_CO',
    name: 'Express++ Livraison Entreprise',
    professionalOffer: false,
    requiredCompanyName: true,
    id: 26
  },
  {
    value: 'EXP10_PRO_CO',
    name: 'Express++ Pro Livraison Entreprise',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 27
  },
  {
    value: 'EXP10',
    name: 'Express++',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 28
  },
  {
    value: 'EXP10_PRO',
    name: 'Express++ Pro',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 29
  },
  {
    value: 'EXP10_ENV_CO',
    name: 'Express++ Pli Livraison Entreprise',
    professionalOffer: false,
    requiredCompanyName: true,
    id: 30
  },
  {
    value: 'EXP10_PRO_ENV_CO',
    name: 'Express++ Pro Pli Livraison Entreprise',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 31
  },
  {
    value: 'EXP10_ENV',
    name: 'Express++ Pli',
    professionalOffer: false,
    requiredCompanyName: false,
    id: 32
  },
  {
    value: 'EXP10_PRO_ENV',
    name: 'Express++ Pro Pli',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 33
  },
  {
    value: 'STD_PRO_PICKUP_POINT',
    name: 'Standard Pro Relais',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 34
  },
  {
    value: 'EXP_PRO_PICKUP_POINT',
    name: 'Express Pro Relais',
    professionalOffer: true,
    requiredCompanyName: false,
    id: 35
  },
  {
    value: 'STD_ENV_CO',
    name: 'Standard Pli Livraison Entreprise',
    professionalOffer: false,
    requiredCompanyName: true,
    id: 36
  },
  {
    value: 'STD_PRO_ENV_CO',
    name: 'Standard Pro Pli Livraison Entreprise',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 37
  },
  {
    value: 'STD_ENV',
    name: 'Standard Pli',
    professionalOffer: false,
    requiredCompanyName: true,
    id: 38
  },
  {
    value: 'STD_PRO_ENV',
    name: 'Standard Pro Pli',
    professionalOffer: true,
    requiredCompanyName: true,
    id: 39
  }
];

const getOfferCode = accountType =>
  offerCode.filter(
    code => code.professionalOffer === (accountType === 'professional')
  );

export default getOfferCode;
